import Vue from 'vue'
import KyligenceUI from 'kyligence-ui'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import 'kyligence-ui/lib/theme-chalk/index.css'
import enLocale from 'kyligence-ui/lib/locale/lang/en'
import zhLocale from 'kyligence-ui/lib/locale/lang/zh-CN'
import renamePage from './renamePage'
import googleValidate from 'google-libphonenumber'
Vue.prototype.$http = axios
Vue.axios = axios
const renamePageVUE = document.getElementById('free-trial-vue1');
import VueCountryCode from "./vue-country-code.js";
Vue.use(VueI18n)
Vue.locale('CN', zhLocale)
Vue.locale('US', enLocale)
Vue.use(VueCountryCode)
Vue.use(googleValidate)
Vue.use(KyligenceUI)
Vue.config.lang = document.documentElement.lang.includes('CN') ? 'CN' : 'US'
// const lang = document.documentElement.lang.includes('CN') ? 'CN' : 'US'
// function getCookie (cname) {
//     var name = cname + '='
//     var ca = document.cookie.split(';')
//     for (var i = 0; i < ca.length; i++) {
//       var c = ca[i]
//       while (c.charAt(0) === ' ') c = c.substring(1)
//       if (c.indexOf(name) !== -1) return c.substring(name.length, c.length)
//     }
//     return ''
//   }
  if (renamePageVUE) {
    new Vue({
        render: h => h(renamePage),
    }).$mount('#free-trial-vue1')
}
// const flag = getCookie('is_white_user') === 'false' ? false : true
// if (renamePageVUE) {
//     if (lang === 'US' || (lang === 'CN' && flag)) {
//         new Vue({
//             render: h => h(renamePage),
//         }).$mount('#free-trial-vue1')
//     }
// }



// WEBPACK FOOTER //
// ./App/components/renamePage/index.js